module.exports = __webpack_public_path__ + "static/media/4 1 Skrivehastighet Intro.9070824f.mp3";